import { GatewayType, getGateway } from "../../../gateways/gatewayRegistry";
import { AxiosResponse } from "axios";
import { AreaByScopeOfWork } from "../types/scope-of-work.interface";
import { TSquareFootage } from "../types/square-footage";

interface TypeOfService {
  costBias: number;
  baseRatePerHour: number;
}

interface SalesResponse {
  mainAreas: {
    areas: any[];
    cost: number;
    time: {
      minutes: number;
      formatted: string;
    };
  };
  otherAreas: {
    areas: any[];
    cost: number;
    time: {
      minutes: number;
      formatted: string;
    };
  };
  additionalObjects: {
    cost: number;
    time: {
      minutes: number;
      formatted: string;
    };
  };
  specialRequests: number;
  bufferTime: number;
  increasePercentageByFrequency: number;
  cost: number;
  time: {
    minutes: number;
    formatted: string;
  };
}

export const getSales = async ({
  areas,
  typeOfService,
  squareFootage,
  travelBufferTimeInGeneral = 30,
  frequencyType = "by_weekly",
  otherAreas = [],
  additionalObjects = [],
  specialRequests = [],
}: {
  areas: AreaByScopeOfWork[];
  typeOfService: TypeOfService;
  squareFootage: TSquareFootage;
  travelBufferTimeInGeneral?: number;
  frequencyType?: string;
  otherAreas?: any[];
  additionalObjects?: any[];
  specialRequests?: any[];
}): Promise<AxiosResponse<SalesResponse>> => {
  try {
    if (!squareFootage) {
      throw new Error("Square footage is required");
    }
    if (!typeOfService) {
      throw new Error("Type of service is required");
    }

    const gateway = getGateway(GatewayType.SECTOR_WORKFLOWS);
    const url = `/sales`;
    const fullUrl = `${gateway.defaults.baseURL}${url}`;

    console.log(`[getSales] Calling: ${fullUrl}`);

    const requestBody = {
      squareFootage,
      typeOfService: {
        costBias: typeOfService.costBias,
        baseRatePerHour: typeOfService.baseRatePerHour,
      },
      areas: areas || [],
      otherAreas: otherAreas || [],
      additionalObjects: additionalObjects || [],
      specialRequests: specialRequests || [],
      travelBufferTimeInGeneral: travelBufferTimeInGeneral || 30,
      frequencyType: frequencyType || "by_weekly",
    };

    const response: AxiosResponse<SalesResponse> = await gateway.post<SalesResponse>(url, requestBody);

    return response;
  } catch (error) {
    console.error(`Error getting sales`, error);
    throw error;
  }
};
